import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sjob" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "gra",
  id: "grnhse_app"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Pop = _resolveComponent("Pop")!
  const _component_Tail = _resolveComponent("Tail")!
  const _component_Cookie = _resolveComponent("Cookie")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(_component_Pop),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_Tail)
    ], 512), [
      [_vShow, _ctx.showjob]
    ]),
    (_ctx.showcookie)
      ? (_openBlock(), _createBlock(_component_Cookie, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}